import { render } from "./manage-tg-bot.view.vue?vue&type=template&id=426ef462"
import script from "./manage-tg-bot.view.vue?vue&type=script&lang=js"
export * from "./manage-tg-bot.view.vue?vue&type=script&lang=js"

import "./manage-tg-bot.view.vue?vue&type=style&index=0&id=426ef462&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__